import React, { FunctionComponent } from 'react';

import useTheme from '@gojob/ui-bits/styles/useTheme';
import Text from '@gojob/ui-bits/Text';
import BlockContent from '@sanity/block-content-to-react';

const getTextVariant = (style = 'normal') => {
  switch (style) {
    case 'h1':
    case 'h2':
      return 'headline2';
    case 'h3':
      return 'headline3';
    case 'h4':
      return 'headline4';
    default:
      return 'paragraph';
  }
};

const getElement = (style = 'normal') => {
  switch (style) {
    case 'h1':
    case 'h2':
    case 'h3':
    case 'h4':
    case 'h5':
      return style;
    default:
      return 'p';
  }
};

const getStyles = (style = 'normal') => {
  const { spacing } = useTheme();
  switch (style) {
    case 'h1':
    case 'h2':
    case 'h3':
    case 'h4':
    case 'h5':
      return { marginTop: spacing(3) };
    default:
      return {};
  }
};

const blockRenderer = (props: any) => {
  const variant = getTextVariant(props.node.style);
  const element = getElement(props.node.style);
  const styles = getStyles(props.node.style);

  return (
    <Text gutter={2} as={element} variant={variant} css={styles}>
      {props.children}
    </Text>
  );
};

/** We have to remove this renderer as we can not consume images from simultaneously gojob-board and gojob-home */
const inlineImageRenderer = () => null;

export type BlockRendererProps = {
  blocks?: any;
};

const BlockRenderer: FunctionComponent<BlockRendererProps> = (props) => {
  const { blocks } = props;
  return (
    <BlockContent
      blocks={blocks}
      serializers={{ types: { block: blockRenderer, 'inline-image': inlineImageRenderer } }}
    />
  );
};

export default BlockRenderer;
